import React, { Fragment, useState } from 'react';
import { UPDATE, GET_ONE, GET_MANY } from 'ra-core';
import { Button as AdminButton, useTranslate, useDataProvider, useRefresh } from 'react-admin';
import { useSnackbar } from 'notistack';
import SendIcon from '@mui/icons-material/Send';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';

import ResultDialog from '../../../Utilities/ResultDialog';

function SendToSapButton() {
    const [isOpen, setIsOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingTitle, setLoadingTitle] = useState('');
    const [msg, setMsg] = useState("");
    const [devices, setDevices] = useState([]);

    const dataProvider = useDataProvider();
    const {enqueueSnackbar} = useSnackbar();
    const translate = useTranslate();
    const refresh = useRefresh();

    const handleClick = async () => {
        setLoading(true);
        setLoadingTitle('Cercando...');
        var user = localStorage.getItem('username');
        //Get all devices with status Approvato
        var devices = await dataProvider(GET_MANY, 'devices', { "filter": { "status": { "codice": "4" }, "approved_by": user, "causale": { $ne: null } } })
            .then(
                response => {
                    if (response.total > 0)
                        return response.data;
                    else
                        return undefined;
                })
            .catch(error => {
                console.log(error);
                this.showMessage(translate('tim.sendtosap.error'), "error");
            });

        if (devices) {
            var filteredDevices = [];

            let filter = await dataProvider(GET_ONE, 'settings', { name: 'NMUGestitoFilter' });
            await asyncForEach(devices, filter.data.value, async (response) => {
                if (response !== "Not found") {
                    filteredDevices.push(response);
                }
            });

            if (filteredDevices && filteredDevices.length > 0) {
                setDevices(filteredDevices);
                setMsg(translate('tim.sendtosap.confirm_message', { d: filteredDevices.length }));
                setIsOpen(true);
                setLoading(false);
            }
            else {
                setLoading(false);
                showMessage(translate('tim.sendtosap.noDevices'), "warning");
            }
        }
        else {
            setLoading(false);
            showMessage(translate('tim.sendtosap.noDevices'), "warning");
        }
    }



    const handleDialogClose = () => {
        setIsOpen(false);
    };

    const handleConfirm = async () => {
        setIsOpen(false);
        setLoading(false);
        setLoadingTitle('Aggiornando...');

        var devicesId = [];
        devices.forEach(function (d) {
            devicesId.push(d.id);
        })

        var user = localStorage.getItem('username');
        dataProvider(UPDATE, 'sendtosap', {
            "username": user,
            "body": devicesId
        })
            .then(
                response => {
                    if (response.data && response.data.message && response.data.message === "Success") {
                        showMessage(translate('tim.sendtosap.success', { n: response.data.totalUpdated }), "success");
                        setLoading(false);
                        refresh();
                    }
                    else {
                        console.log(response);
                        setLoading(false);
                        showMessage(translate('tim.sendtosap.error'), "error");
                    }

                })
            .catch(error => {
                console.log(error);
                setLoading(false);
                showMessage(translate('tim.sendtosap.error'), "error");
            });
    };

    const showMessage = (message, level) => {
        enqueueSnackbar(message, {
            variant: level,
            anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'center',
            },
            autoHideDuration: 3000,
        });
    }

    const asyncForEach = async (array, settings, callback) => {
        for (let index = 0; index < array.length; index++) {
            if (array[index].cod_nmu && array[index].cod_nmu !== null) {
                settings.cod_nmu = array[index].cod_nmu;
                let filter = settings;
                await dataProvider(GET_MANY, 'nomenclatores', { "filter": filter })
                    .then(
                        response => {
                            if (response.data.message || response.data && response.data.length < 1) {
                                callback("Not found");
                            }
                            else {
                                callback(array[index]);
                            }
                        })
                    .catch(error => {
                        callback(error);
                    });
            }
        }
    };

    return (
        <Fragment>
            <AdminButton label='tim.sendtosap.button_label' onClick={handleClick} >
                <SendIcon />
            </AdminButton>
            <Dialog
                open={isOpen}
                onClose={handleDialogClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{translate('tim.sendtosap.title')}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {msg}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDialogClose} color="primary" autoFocus><div>{translate('tim.sendtosap.cancel')}</div></Button>
                    <Button onClick={handleConfirm} color="primary" autoFocus><div>{translate('tim.sendtosap.confirm')}</div></Button>
                </DialogActions>
            </Dialog>
            <ResultDialog
                open={loading}
                rows={[[]]}
                headers={[]}
                loading={true}
                title={loadingTitle} />
        </Fragment>
    );
}

export default SendToSapButton;